// react
import { ReactNode } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Box, Grid, Paper, Typography } from '@mui/material';

// icons
import { AccessTimeOutlined as IconAccessTime } from '@mui/icons-material';

// props
export interface UpcomingProps {
	features: ReactNode[];
}

export const Upcoming = ({ features }: UpcomingProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<Paper sx={{ height: '100%', width: '100%' }}>
			<Box sx={(theme) => ({ padding: theme.spacing(2) })}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography fontWeight={700}>{t('upcomingFeatures')}</Typography>
					</Grid>
					<Grid item xs={12}>
						<Grid container spacing={2}>
							{features.map((feature, i) => (
								<Grid alignItems="center" container item key={`upcoming-${i}`} spacing={1} xs={12}>
									<Grid item xs="auto">
										<IconAccessTime fontSize="small" />
									</Grid>
									<Grid item xs={true}>
										<Typography variant="body2">{feature}</Typography>
									</Grid>
								</Grid>
							))}
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};
